export default __webpack_public_path__ + "static/media/Avatar-20.7efd899b.png";